"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAssert = void 0;
const process_1 = __importDefault(require("process"));
function useAssert(shouldShow, message, options) {
    if (process_1.default.env.NODE_ENV !== "production" && shouldShow) {
        if (options === null || options === void 0 ? void 0 : options.warn) {
            console.warn(message);
        }
        else {
            throw new Error(message);
        }
    }
}
exports.useAssert = useAssert;
